export const listenOpts = {
  hasPassive: false,
  passiveCapture: true,
  notPassiveCapture: true
}

// Function to prevent the default behavior of an event
export function prevent(e) {
  e.cancelable !== false && e.preventDefault()
}

// Function to add event listeners
export function addEvt(ctx, targetName, events) {
  const name = `${targetName}_evt`

  ctx[name] = ctx[name] !== undefined ? ctx[name].concat(events) : events

  events.forEach((evt) => {
    evt[0].addEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]])
  })
}

// Function to clean up (remove) event listeners
export function cleanEvt(ctx, targetName) {
  const name = `${targetName}_evt`

  if (ctx[name] !== undefined) {
    ctx[name].forEach((evt) => {
      evt[0].removeEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]])
    })
    ctx[name] = undefined
  }
}

export default {
  listenOpts,
  prevent,
  addEvt,
  cleanEvt
}
